import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoReplenishmentALV1Component } from './auto-replenishment-al-v1.component'


@NgModule({
  declarations: [AutoReplenishmentALV1Component],
  exports: [
    AutoReplenishmentALV1Component
  ],
  imports: [
    CommonModule,
  ],
  providers: [
  ]
})
export class AutoReplenishmentALV1Module { }
